
import { Browse } from "@/models/browse";
import { HumanFilter } from "@/utils/human-filter";
import { Model } from "@/utils/models/model";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppFilterEdit from "../models/HumanFilterEdit.vue";

export default Vue.extend({
	props: {
		filter: {
			type: Object as ()=>HumanFilter,
			required: true
		},
		isEditing: Boolean,
		model: {
			type: Object as ()=>Model,
			required: true
		},
		browse: {
			type: Object as ()=>Browse,
			required: true
		}
	},
	computed: {
		filterText():TranslateResult{
			return this.filter.getTranslatedText(this.model);
		}
	},
	methods: {
		editFilter(){
			this.$emit("edit");
		},
		removeFilter(){
			this.$emit("remove");
		}
	},
	components: {
		AppFilterEdit

	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
